import $ from 'jquery';
import thirdPartyCookies from '../../utils/third_party_cookie';
import screenSize from '../../services/screen_size';

export function handleAdmin(e) {
    if (e && e.preventDefault) {
        e.preventDefault();
    }

    const $drupalAdminContainer = $('.drupal-admin-panel');
    const $iframe = $('.drupal-admin-panel iframe');

    // Inserts an iframe to drupal admin panel and slide it in from the right if the iframe is not found
    if ($iframe.length !== 1) {
        $drupalAdminContainer.html('<div class="toolbarFrame hide-for-medium-down"><div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div><div class="instruction-text">Make sure your are <a href="//www.fastcompany.com/login">logged in</a> to the CMS</div><iframe src="//www.fastcompany.com/3004508/fctoolbar" style="border: 0px none rgb(255, 255, 255); height: 100vh; width: 260px" scrolling="no" frameborder="0" marginheight="0px" marginwidth="0px" width="260px"></iframe></div>');

        $('.drupal-admin-panel iframe').on('load', function () {
            $('.spinner, .instruction-text').hide();
        });
    }

    if ($drupalAdminContainer.hasClass('open')) {
        // If the drupal admin panel is already opened Hide it and slide it to the right
        $('.toolbarFrame', $drupalAdminContainer).animate({width: 0}, 500, function () {
            $drupalAdminContainer.hide();
            // remove cookie
        });

        // Undo margin on body
        $('body').animate({'margin-right': 0}, 500);

        // Unbind resize event when panel is hidden
        $(window).unbind('resize.drupal-admin-panel');
        $drupalAdminContainer.removeClass('open');
        localStorage.setItem('adminOpen', false);
    } else {
        // add cookie
        localStorage.setItem('adminOpen', true);
        // If the drupal admin panel is closed, then show it
        $('.toolbarFrame', $drupalAdminContainer).animate({width: '280px'}, 500, function () {
            $drupalAdminContainer.show();
        });

        $('body').animate({'margin-right': '285px'}, 500);

        // Make sure iframe is always same as window height on resize
        $(window).bind('resize.drupal-admin-panel', function () {
            let elems = $.merge($('.toolbarFrame', $drupalAdminContainer), $drupalAdminContainer.find('iframe'));
            elems.height($(window).height());
        });

        $drupalAdminContainer.addClass('open');
    }
}

export function initializeAdmin() {
    var nid;
    // Don't take user anywhere on outer level menu item
    $('.admin-controls .has-dropdown>a').click(function (e) {
        e.preventDefault();
    });

    // Inner level items
    $('.admin-controls .has-dropdown').click(function () {
        const $this = $(this);
        const $childMenu = $this.children('.hidden-burger');
        const $childMenuFirstLink = $this.children('a');

        if ($childMenu.length && $childMenu.hasClass('admin-expanded')) {
            $childMenu.removeClass('admin-expanded');
            $childMenuFirstLink.removeClass('opened');
        } else {
            $childMenu.addClass('admin-expanded');
            $childMenuFirstLink.addClass('opened');
        }
    });

    if (document.cookie.indexOf('fastcache') !== -1) {
        // Command E to edit a node on article page
        $(document).on('keydown keypress', function (event) {
            const keyCode = event.which;
            if (event.metaKey && (keyCode === 69)) {
                if (window.bootstrap_id) {
                    nid = window.bootstrap_id;
                }

                if (nid && nid !== 'homepage') {
                    window.location = `http://www.fastcompany.com/node/${nid}/edit`;
                }
            }
        });

        if (localStorage.getItem('adminOpen') === 'true') {
            handleAdmin();
        }
    }

    if (screenSize.getSize() === 'small') {
        $('.publicBetaOptOut').hide();
    }

    // Opt out of redesign, just set cookie for theme_ver to 1 in the base path.
    $('.redesign-opt-out').click(function (e) {
        e.preventDefault();

        $('html, body').animate({scrollTop: 0}, 'fast', function () {
            $('.public-beta-optout-shade, .public-beta-optout-overlay').slideDown(800);
        });

        // Opt out of redesign, just set cookie for theme_ver to 1 in the base path.
        $('.beta-optout-button-ok').on('click', function () {
            $.when(
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//m.fastcompany.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//m.fastcodesign.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//m.fastcocreate.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//m.fastcoexist.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//m.fastcolabs.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//www.fastcompany.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//www.fastcodesign.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//www.fastcoexist.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//www.fastcocreate.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                }),
                $.ajax({
                    type: 'GET',
                    dataType: 'jsonp',
                    url: '//www.fastcolabs.com/api/v3/beta-opt-out?callback=?'
                }, function () {
                })
            ).then(function () {
                thirdPartyCookies('removeCookies', [{name: 'theme_ver'}]);
                window.location.reload();
            });
        });

        // Close Modal
        $('.public-beta-optout-shade, .beta-optout-button-cancel').on('click', function () {
            $('.public-beta-optout-shade, .public-beta-optout-overlay').slideUp(800);
        });
    });


    // When user clicks the Drupal Admin Panel
    $('.admin-panel-menu-button').on('click', handleAdmin);
}
